<template>
  <div id="clusters">
    <!-- the user has no cluster => display the warning page -->
    <!-- check true and false to not display anything while it's null -->
    <no-groups v-if="this.$store.getters.userHasClusters===false" groups="clusters" />

    <template v-else>
      <select-group group="cluster" />

      <div class="row">
        <div class="col-lg-5">
          <properties :cluster="selectedCluster" />
        </div>
      </div>

      <overview :end-devices="endDevices" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import to from '@/modules/await-to-js'

import NoGroups from '@/components/page/errors/NoGroups'
import Properties from './Properties'
import Overview from './Overview'

export default {
  titleKey: 'clusters',

  components: { NoGroups, Properties, Overview },

  data () {
    return {
      endDevices: {}
    }
  },

  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(['selectedCluster'])
  },

  watch: {
    selectedCluster: 'getAllClusterEndDevices'
  },

  methods: {
    async getAllClusterEndDevices () {
      // Filter by selected cluster
      const search = this.$utils.addSearch([], 'eq', this.selectedCluster.id, 'cluster.id')

      let error, response
      [error, response] = await to(this.$api.getAllEndDevices(this.$store.getters.application, { search: JSON.stringify(search[0]) }))
      if (error || !response) return

      this.endDevices = response.data
    }
  }
}
</script>
